let data,
    currectSelectedYearString,
    currectSelectedMakeString,
    currectSelectedModelString;



document.addEventListener("DOMContentLoaded", function() {
  // Fetch data
  fetch('/apps/gadget/part-filters')
  .then(response => {
    if (!response.ok) {
      throw new Error('Network response was not ok ' + response.statusText);
    }
    return response.json(); 
  })
  .then(resData => {
    data = resData;

    // Set Year options
    setYearOptions(data);
    
  })
  .catch(error => {
    console.error('There was a problem with the fetch operation:', error);
  });  
  

});


// Sort Years
function sortYears(years) {
  return years.sort((a, b) => parseInt(a.value) - parseInt(b.value));
}


function setYearOptions(data){
  const selectElement = document.querySelector('.filter--year');

  // Clear any existing options
  // selectElement.innerHTML = '';

  // Sort the years array using the sortYears function
  const sortedYears = sortYears(data.years);

  // Iterate through the years array
  sortedYears.forEach(year => {
    // Create a new option element
    let option = document.createElement('option');
    option.value = year.value; // Set the value of the option
    option.textContent = year.value; // Set the display text of the option

    // Set the onClick attribute to call setMakeOptions with the year value
    option.setAttribute('onclick', `setMakeOptions('${year.value}');`);

    // Append the option to the select element
    selectElement.appendChild(option);
  });
}



function setMakeOptions(year) {
  // Get the select element with the class 'filter--make'
  const makeSelectElement = document.querySelector('.filter--make');

  // Clear any existing options
  makeSelectElement.innerHTML = '';

  // Create empty option node
  // <option class="default" value="" selected disabled>{{ block.settings.placeholder }}</option>
  const emptyOption = document.createElement('option');
  emptyOption.className = 'default'; 
  emptyOption.value = ''; 
  emptyOption.textContent = makeSelectElement.getAttribute('data-placeholder'); // Placeholder text
  emptyOption.selected = true; // Set as selected
  emptyOption.disabled = true; // Disable the option

  // Append the empty option to the select element
  makeSelectElement.appendChild(emptyOption);

  // Find the year object in the data
  const yearData = data.years.find(y => y.value === year);

  // If the year is found and it has makes, populate the makes
  currectSelectedYearString = year
  if (yearData && yearData.makes) {
      yearData.makes.forEach(make => {
        // Create a new option element
        let option = document.createElement('option');
        option.value = make.value; // Set the value of the option
        option.textContent = make.value; // Set the display text of the option

        // Append the option to the select element
        makeSelectElement.appendChild(option);
      });
  }
}




function setModelOptions(make) {
  const modelSelectElement = document.querySelector('.filter--model');

  // Clear any existing options
  modelSelectElement.innerHTML = '';

  // Create empty option node
  const emptyOption = document.createElement('option');
  emptyOption.className = 'default'; 
  emptyOption.value = ''; 
  emptyOption.textContent = modelSelectElement.getAttribute('data-placeholder'); // Placeholder text
  emptyOption.selected = true; // Set as selected
  emptyOption.disabled = true; // Disable the option

  // Append the empty option to the select element
  modelSelectElement.appendChild(emptyOption);

  currectSelectedMakeString = make;

  // Find the year object in the data
  let tempYearData = data.years.find(y => y.value === currectSelectedYearString);

  // If the year is found and it has makes, find the selected make
  if (tempYearData && tempYearData.makes) {
    const makeData = tempYearData.makes.find(m => m.value === currectSelectedMakeString);

    // If the make is found and it has models, populate the models
    if (makeData && makeData.models) {
      makeData.models.forEach(model => {
        // Create a new option element for each model
        let option = document.createElement('option');
        option.value = model.value; // Set the value of the option
        option.textContent = model.value; // Set the display text of the option

        // Append the option to the select element
        modelSelectElement.appendChild(option);
      });
    }
  }

}


function setVROptions(model) {
  const variantSelectElement = document.querySelector('.filter--vehicle');

  // Clear any existing options
  variantSelectElement.innerHTML = '';

  // Create empty option node
  const emptyOption = document.createElement('option');
  emptyOption.className = 'default'; 
  emptyOption.value = ''; 
  emptyOption.textContent = variantSelectElement.getAttribute('data-placeholder'); // Placeholder text
  emptyOption.selected = true; // Set as selected
  emptyOption.disabled = true; // Disable the option

  // Append the empty option to the select element
  variantSelectElement.appendChild(emptyOption);

  currectSelectedModelString = model;

  // Find the year object in the data
  let tempYearData = data.years.find(y => y.value === currectSelectedYearString);

  // If the year is found and it has makes, find the selected make
  if (tempYearData && tempYearData.makes) {
      let tempMakeData = tempYearData.makes.find(m => m.value === currectSelectedMakeString);

      // If the make is found and it has models, find the selected model
      if (tempMakeData && tempMakeData.models) {
          const modelData = tempMakeData.models.find(m => m.value === currectSelectedModelString);

          // If the model is found and it has variants, populate the variants
          if (modelData && modelData.variants) {
              modelData.variants.forEach(variant => {
                  // Create a new option element for each variant
                  let option = document.createElement('option');
                  option.value = variant.value; // Set the value of the option
                  option.textContent = variant.value; // Set the display text of the option

                  // Append the option to the select element
                  variantSelectElement.appendChild(option);
              });
          }
      }
  }
}


